import messages from './cmsCatalog.json' with { type: 'json' };

export const cmsCatalogEn: Readonly<typeof messages> = messages;
